import React, { Component } from 'react';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openAlertModal } from 'admin/actions/alert-modal';
import { showLoadingSpinner, hideLoadingSpinner } from 'admin/actions/loading-spinner';
import { resetUser } from 'admin/actions/user';
import OnePane from '../../templates/OnePane';

export class PasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organization: '',
      email: '',
    };
  }

  onChangeOrganization(e) {
    this.setState({ organization: e.target.value });
  }

  onChangeEmail(e) {
    this.setState({ email: e.target.value });
  }

  openModal(message) {
    this.props.openAlertModal({
      body: (<p>{ message }</p>),
      confirmText: '閉じる',
      useCancel: false,
    });
  }

  invalidParamsMessage(params) {
    const name = { organization: '組織コード', email: 'Eメールアドレス' };
    return params.map(p => name[p]).filter(p => !!p).join('と');
  }

  onReset(e) {
    e.preventDefault();
    this.props.showLoadingSpinner();
    resetUser(this.state.organization, this.state.email).then((response) => {
      this.props.hideLoadingSpinner();
      if (response.ok) {
        this.openModal('パスワード再設定用メールの送信に成功しました。メールを確認し、パスワード再設定を完了してください');
      } else {
        response.json().then((e) => {
          const { errors, type, message } = e;
          switch (type) {
            case 'invalid_parameters':
              this.openModal(`${this.invalidParamsMessage(errors.invalid)}に誤りがあります。入力内容をご確認ください。`);
              break;
            default:
              this.openModal(message || '処理に失敗しました');
          }});
      }
    });
  }

  render() {
    return (
      <OnePane>
        <Form method="post" onSubmit={this.onReset.bind(this)}>
          <FormGroup>
            <Label for="user-organization">組織コード</Label>
            <Input
              type="text"
              id="user-organization"
              name="organization"
              placeholder="組織コード"
              value={this.state.organization}
              onChange={this.onChangeOrganization.bind(this)}
            />
            <p>※ 組織コードは管理ユーザ登録時に送られた招待メール内に記載してあります。</p>
          </FormGroup>
          <FormGroup>
            <Label for="user-email">Eメールアドレス</Label>
            <Input
              type="email"
              id="user-email"
              name="email"
              placeholder="Eメールアドレス"
              value={this.state.email}
              onChange={this.onChangeEmail.bind(this)}
            />
          </FormGroup>
          <Button type="submit" color="danger">パスワード再発行</Button>
        </Form>
      </OnePane>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  showLoadingSpinner,
  hideLoadingSpinner,
  openAlertModal,
}, dispatch);

export default connect(null, mapDispatchToProps)(PasswordReset);
